import { render } from "./ItemList.vue?vue&type=template&id=26674bf2"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"

import "./ItemList.vue?vue&type=style&index=0&id=26674bf2&lang=css"

import exportComponent from "/home/runner/work/nexty-frontend/nexty-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__